import { render, staticRenderFns } from "./CardCodePromo.vue?vue&type=template&id=0ca05a61&"
import script from "./CardCodePromo.vue?vue&type=script&lang=js&"
export * from "./CardCodePromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports